var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"membershipMeetingsMain"}},[_c('div',[_c('div',{staticClass:"container-membership"},[_c('HaveYouMetCards',{ref:"childComponent"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }